import Grid from '@material-ui/core/Grid'
import React, { FC } from 'react'

//* style
import GlobalContainer from '../globalContainer'
import { BlogCollectionRowContainer } from './style'

//* components
import { BlogImage, Collection } from './subcomponents'

type BlogCollectionRowProps = {
  headline: string
  robotImage: string
  categories:
    | {
        name: string
        description: string
        ctaText: string
      }[]
    | null
  className?: string
}

const BlogCollectionRow: FC<BlogCollectionRowProps> = ({
  headline,
  robotImage,
  categories,
  className,
}) => {
  return (
    <BlogCollectionRowContainer data-cy="blogCollectionRow" className={className || undefined}>
      <GlobalContainer>
        <Grid container className="BlogCollectionRow__Container">
          {headline && <BlogImage robotImage={robotImage} headline={headline} />}

          {categories?.map((item: any, n: number) => (
            <Collection item={item} n={n} key={`BlogCollectionRow__Category--${n}`} />
          ))}
        </Grid>
      </GlobalContainer>
    </BlogCollectionRowContainer>
  )
}

export default BlogCollectionRow
